import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab1 = ({
  IdData,
  SupplierName,
  SupplierGroup,
  SupplierType,
  Territory,
  IsTransporter,
  BillingCurrency,
  DefaultCompanyBankAccount,
  DefaultPriceList,
  IsInternalSupplier,
  RepresentsCompany,
  Website,
  SupplierDetails,
}) => {
  return (
    <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <Input
                    id="SupplierName"
                    style={{
                      height: "30px",
                      border: SupplierName.Error ? "1px solid red" : "",
                    }}
                    label="Supplier Name"
                    value={SupplierName.SupplierName}
                    onChange={(e) => SupplierName.setSupplierName(e.target.value)}
                    readOnly
                  />

                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    style={{
                      height: "30px",
                    }}
                    label="Supplier Group"
                    value={SupplierGroup.select_SupplierGroup}
                    readOnly
                  />
                



                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    style={{
                      height: "30px",
                    }}
                    label="Supplier Type"
                    value={SupplierType.SupplierType}
                    readOnly
                  />
                 
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <Input
                    style={{
                      height: "30px",
                    }}
                    label="Territory"
                    value={Territory.select_Territory}
                    readOnly
                  />
                 
                </div>


                <div style={{ flex: 1 }}>
                  <Input
                    id="Website"
                    style={{
                      height: "30px",
                      border: Website.Error ? "1px solid red" : "",
                    }}
                    label="Website"
                    value={Website.Website}
                    onChange={(e) => Website.setWebsite(e.target.value)}
                    readOnly
                  />

                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                 <Checkbox
                    id="IsTransporter"
                    label="Is Transporter"
                    value={IsTransporter?.IsTransporter || false}
                    onChange={(val) => IsTransporter?.setIsTransporter?.(val)}
                    disabled={true}
                  />
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Defaults</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>


               <div style={{ flex: 1 }}>
                   <Input
                    style={{
                      height: "30px",
                    }}
                    label="Billing Currency"
                    value={BillingCurrency.select_BillingCurrency}
                    readOnly
                  />
                 

                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    style={{
                      height: "30px",
                    }}
                    label="Default Company Bank Account"
                    value={DefaultCompanyBankAccount.select_DefaultCompanyBankAccount}
                    readOnly
                  />
                 



                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    style={{
                      height: "30px",
                    }}
                    label="Default Price List"
                    value={DefaultPriceList.select_DefaultPriceList}
                    readOnly
                  />
                 
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>



                <div style={{ flex: 1 }}>

                  <Input
                    id="SupplierDetails"
                    style={{
                      height: "30px",
                      border: SupplierDetails?.Error ? "1px solid red" : "",
                    }}
                    label="Supplier Details"
                    value={SupplierDetails.SupplierDetails}
                    onChange={(e) =>
                      SupplierDetails.setSupplierDetails(e.target.value)
                    }
                    readOnly
                  />
                  <p
                    style={{
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      lineHeight: '2',
                      fontFamily: "Roboto, sans-serif",
                      marginTop: '-8px'
                    }}
                  >
                    Statutory info and other general information about your Supplier
                  </p>


                </div>



              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  {/* <label style={{ height: '2px' }}></label> */}
                  <Checkbox
                    id="IsInternalSupplier"
                    label="Is Internal Supplier"
                    value={IsInternalSupplier?.IsInternalSupplier || false}
                    // onChange={(val) =>
                    //   IsInternalSupplier?.setIsInternalSupplier?.(val)
                    // }
                    disabled={true}
                    onChange={(val) => {
                      IsInternalSupplier?.setIsInternalSupplier?.(val);

                      // Clear select value when unchecked
                      if (!val) {
                        RepresentsCompany?.setselect_RepresentsCompany?.(''); // or ''
                      }
                    }}
                  />
                </div>
                 <div style={{ flex: 1 }}>
    {IsInternalSupplier?.IsInternalSupplier ? (  // ✅ render only when true
      <Input
        style={{
          height: "30px",
        }}
        label="Represents Company"
        value={RepresentsCompany?.select_RepresentsCompany || ''}
        readOnly
      />
    ) : null} {/* ✅ render nothing when unchecked */}
  </div>
                <div style={{ flex: 1 }}></div>
              </div>

            </div>
          </div>
        </div>
         <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Supplier" docname={IdData} />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Tab1;
